import { Typography, styled, Box } from '@mui/material';

export const NoMessageContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const NoMessageText = styled(Typography)({
  fontFamily: 'AvenirNext-Medium',
  fontSize: '18px',
  textAlign: 'left',
  color: '#393060',
  paddingLeft: '5px',
  paddingRight: '5px',
});
